import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  GET_DAILY_SESSION_NOTES_FAILURE,
  GET_DAILY_SESSION_NOTES_REQUEST,
  GET_DAILY_SESSION_NOTES_SUCCESS,
  GET_DAILY_SESSION_NOTES_LOADING,
} = dailySessionNotes;

function* getDailySessionNotes(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DAILY_SESSION_NOTES_LOADING });

    const response = yield call(dailySessionNotesService.getDailySessionNotes, payload?.payload, payload.source);
    if (response?.status === 200) {
      yield put({ type: GET_DAILY_SESSION_NOTES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DAILY_SESSION_NOTES_FAILURE, payload: error });
  }
}

function* getDailySessionNotesSaga() {
  yield takeEvery(GET_DAILY_SESSION_NOTES_REQUEST, getDailySessionNotes);
}

export default getDailySessionNotesSaga;
